import { TeamsOverview } from "./TeamsOverview";
import { useDocumentTitle } from "../hooks/useDocumentTitle";

export function TeamsPage() {
  useDocumentTitle('Teams – qtplan');
  return <TeamsOverview />;
}
